import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/auth';

var config = {
  apiKey: "AIzaSyDNO0dBjCdiEUj539AzBZg4YdpdB1IypPw",
  authDomain: "fishing-web.firebaseapp.com",
  databaseURL: "https://fishing-web.firebaseio.com",
  projectId: "fishing-web",
  storageBucket: "fishing-web.appspot.com",
  messagingSenderId: "10247225706"
};

firebase.initializeApp(config);

const firebaseDB = firebase.database();
const FirebaseProducts = firebaseDB.ref('Продукты')

export {
  firebase,
  firebaseDB,
  FirebaseProducts
}